<app-seo-hero
  [title]="seoHeroConfig.title"
  [content]="seoHeroConfig.content"
  [illustrationSrc]="seoHeroConfig.illustrationSrc"
></app-seo-hero>

<section class="seo-container">
  <ng-content></ng-content>
</section>
